import { Box, SxProps, Theme } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";
import { ReactNode } from "react";

type FlexBoxDirection = "column" | "row" | "row-reverse" | "column-reverse";
type FlexBoxStyle = "contained" | "default";
type FlexBoxSize = "regular" | "large";

interface FlexBoxProps {
  children?: ReactNode;
  sx?: SxProps<Theme>;
  direction?: FlexBoxDirection;
  gap?: string;
  alignItems?: string;
  justifyContent?: string;
  style?: FlexBoxStyle;
  variant?: FlexBoxStyle;
  size?: FlexBoxSize;
  flex?: number;
  stackedMobile?: boolean;
  enableHeightAnimation?: boolean;
  animationDuration?: string;
  maxHeight?: string | number;
}

export default ({
  children,
  sx,
  direction = "row",
  justifyContent = "start",
  alignItems,
  gap = "12px",
  variant = "default",
  size = "regular",
  flex = 1,
  stackedMobile,
  enableHeightAnimation,
  animationDuration = "1.5s",
  maxHeight,
}: FlexBoxProps) => {
  const isMobile = useIsMobile();
  const containedStyles =
    variant === "contained"
      ? {
          background: "white",
          padding: size == "large" && !isMobile ? "20px 24px" : "16px 20px",
          borderRadius: "12px",
          border: "1px solid #D4D4D4",
        }
      : {};
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: stackedMobile && isMobile ? "column" : direction,
        justifyContent: justifyContent,
        gap: gap,
        flex: flex,
        alignItems: alignItems
          ? alignItems
          : direction === "row" && !isMobile
            ? "center"
            : "start",
        transition:
          enableHeightAnimation && maxHeight
            ? `max-height ${animationDuration} cubic-bezier(0.4, 0, 0.2, 1)`
            : enableHeightAnimation
              ? `height ${animationDuration} cubic-bezier(0.4, 0, 0.2, 1), min-height ${animationDuration} cubic-bezier(0.4, 0, 0.2, 1), max-height ${animationDuration} cubic-bezier(0.4, 0, 0.2, 1)`
              : "none",
        maxHeight: maxHeight,
        overflow: maxHeight ? "hidden" : undefined,
        "& > div": {
          ...(direction === "column" ? { width: "100%" } : {}),
        },
        ...containedStyles,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
